import { Typography, Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default function StepDisplay({ step }) {
  const statusColors = {
    passed: 'success.light',
    failed: 'error.main',
    skipped: 'warning.light',
    pending: 'text.disabled',
  };

  const statusIcons = {
    passed: '✓',
    failed: '✗',
    skipped: '○',
    pending: '·',
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        py: 0.5,
        px: 1,
        borderRadius: 1,
        bgcolor: (theme) =>
          step.status === 'failed' ? alpha(theme.palette.error.main, 0.1) : 'transparent',
      }}
    >
      <Typography
        component="span"
        sx={{
          color: statusColors[step.status],
          fontWeight: 'bold',
          minWidth: 20,
          fontFamily: 'monospace',
        }}
      >
        {statusIcons[step.status]}
      </Typography>

      <Typography
        component="span"
        sx={{
          color: 'custom.terminalKeyword',
          fontWeight: 500,
          minWidth: 50,
          fontFamily: 'monospace',
        }}
      >
        {step.keyword}
      </Typography>

      <Typography
        component="span"
        sx={{
          color: step.status === 'failed' ? 'error.main' : 'custom.terminalTextLine',
          fontFamily: 'monospace',
          flex: 1,
        }}
      >
        {step.text}
      </Typography>
    </Box>
  );
}
